import React from 'react';
import Avatars from 'Pub/js/defaultAvatar';

export default function AvatarImg(props) {
    let { imgUrl, ...otherProps } = props;
    return (
        <img
            src={imgUrl || Avatars.avatar1}
            alt='logo'
            fieldid='userlogo_img' //自动化测试用标记
            {...otherProps}
        />
        //   {
        //     !!avatar ? <img
        //     src={avatar}
        //     alt='logo'
        //     className='img-avatar'
        // /> : <p className='name-avatar'>{getAvatarName(userName)}</p>
        //   }
    )
}